import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'so0010',
    ecrans: ['00-2'],
    params: ['id']
});
